import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import createAction from './';

const SERVICE_WORKER_UNINSTALL = createAsyncAction(createAction('SERVICE_WORKER_UNINSTALL'));

export const workerUninstall = () => (dispatch) => {
  dispatch({ type: SERVICE_WORKER_UNINSTALL.pending });

  return navigator
    .serviceWorker
    .ready
    .then((reg) => reg.unregister())
    .then(() => dispatch({ type: SERVICE_WORKER_UNINSTALL.success }))
    .catch((err) => dispatch(errorAction(SERVICE_WORKER_UNINSTALL.failure, err)));
};
